import type { NewsResponseMediaLinksItemProjectInfoEngagementAllOf } from './newsResponseMediaLinksItemProjectInfoEngagementAllOf';
import type { NewsResponseMediaLinksItemProjectInfoEngagementAllOfTwo } from './newsResponseMediaLinksItemProjectInfoEngagementAllOfTwo';

/**
 * 프로젝트 참여 통계
 */
export type NewsResponseMediaLinksItemProjectInfoEngagement = NewsResponseMediaLinksItemProjectInfoEngagementAllOf & NewsResponseMediaLinksItemProjectInfoEngagementAllOfTwo;
